import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { AuthservicesService } from '../../../services/authservices.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css'],
})
export class AlertComponent implements OnInit {
  loading = false;
  alertsArr: any[] = [];
  objArr: any[] = [];
  colorArr = ['#6ba46d', '#f24e2b', '#f4770b', '#737373'];
  pageSize=10;
  totalItems=0;
  colorIndex = 0;
  type = {
    generalMessage: 'General Message',
    emergencyUpdate: 'Emergency Update',
    importantUpdate: 'Important Update ',
  };
  pageNo=1;
  arr = [1, 2, 3, 4];
  constructor(
    private authService: AuthservicesService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.pageSize = 10;
  }
  ngOnInit(): void {
    this.getAlerts(1);
  }

  getAlerts(event) {
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);

    this.loading = false;
    this.authService.getAlerts(true, skip, this.pageSize).subscribe(
      (res: any) => {
        this.loading = true;
        this.alertsArr = res.items;
        this.totalItems = res.total;
        this.objArr = [];
        this.alertsArr.forEach((e) => {
          this.objArr.push({
            // name: e.name ? e.name : '',
            // description: e.description ? e.description : '',
            // createdAt: e.createdAt ? e.createdAt : '',
            // type: e.type ? this.type[e.type] : '',
            // link: e.link ? e.link : '',
            name: e.name || '',
            description: e.description || '',
            createdAt: e.createdAt || '',
            type: e.type ? this.type[e.type] : '',
            link: e.link || '',

          });
        });
      },
      (error) => {
        // this.authService.successMessage(error.error.message, 'error');
      //   this.authService.successMessage('Login Session Exipired', 'error');
      //   if (error.error.code == 401) {
      //       this.router.navigate(['/login']);
      //   }
        this.loading = false;
        this.authService.successMessage('Login Session Expired', 'error');
        if (error.error?.code === 401) {
          this.router.navigate(['/login']);
        }
      }
    );
  }

  refreshAlerts() {
    this.getAlerts(this.pageNo);
  }

}
